import { action, Action } from "easy-peasy";

export interface EstimateModel {
  formsData: any;
  setFormsData: Action<any, any>;
}

const estimates: EstimateModel = {
  formsData: {},
  setFormsData: action((state: any, payload: any) => {
    state.formsData = {
      ...state.formsData,
      ...payload,
    };
  }),
};

export default estimates;
